import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { Subject, takeUntil } from "rxjs";

import { HotelFiltersService } from "@app/services/hotelfilters.service";
import { ParamFilters } from "@app/models/filtermodels/ParamFilters";
@Component({
    selector: "clever-dauer-small",
    templateUrl: "./dauer.component.html",
    styleUrls: ["./dauer.component.scss"],
    standalone: false,
})
export class DauerSmallComponent {
    @Input() mode: string;
    @Input() bottomleftradius: boolean = false;
    protected unsubscribe$ = new Subject();

    zielText = "Beliebig";

    constructor(
        protected cdr: ChangeDetectorRef,
        protected hotelService: HotelFiltersService
    ) { }

    ngOnInit(): void {
        this.initFilterSub();
    }

    initFilterSub() {
        this.hotelService.getfilters$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((filter: ParamFilters) => {
                if (filter) {
                    this.initDauer(filter);
                }
            });
    }

    initDauer(filter: ParamFilters) {
        this.zielText = "";
        if (Number(filter?.reisezeitraumResult?.minDuration) > 0) {
            this.zielText = filter?.reisezeitraumResult.minDuration + "";
            if (
                filter?.reisezeitraumResult.minDuration !==
                filter?.reisezeitraumResult.maxDuration
            ) {
                if (Number(filter?.reisezeitraumResult.maxDuration) > 0) {
                    this.zielText +=
                        " - " + filter?.reisezeitraumResult.maxDuration + " Tage";
                } else {
                    this.zielText +=
                        Number(filter?.reisezeitraumResult?.minDuration) === 1
                            ? "Tag"
                            : " Tage";
                }
            } else {
                this.zielText +=
                    Number(filter?.reisezeitraumResult?.minDuration) === 1
                        ? "Tag"
                        : " Tage";
            }
        } else if (Number(filter?.reisezeitraumResult?.minDuration) === -1) {
            this.zielText = "exakt wie angegeben";
        } else {
            this.zielText = "Beliebig";
        }

        if (this.zielText === "1 - 99 Tage") {
            this.zielText = "Beliebig";
        }
        this.cdr.detectChanges();
    }
}
